export default "__VITE_ASSET__BIsQcmtT__"